module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9dWaE"))).then(() => module.bundle.root('3a9aZ'));